import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

import {
  updateMetaTags,
  get_stream,
  get_stream_next,
  get_item_query_from_id,
  reversed,
  joinStream
} from '../script';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faX, faArrowUp, faArrowDown, faArrowUpFromBracket, faBookmark} from '@fortawesome/free-solid-svg-icons';
import { faCommentDots } from '@fortawesome/free-regular-svg-icons';


export default function Stream(props) {
  const navigate = useNavigate();

  const [joined_stream, set_joined_stream] = useState(false);
  const [showCommentsModal, setshowCommentsModal] = useState(false);

  const [activeStreamItem, setactiveStreamItem] = useState([]);
  const [commentTitle, setcommentTitle] = useState([]);
  const [commentList, setcommentList] = useState([]);

  const [streamData, setstreamData] = useState([]);
  const [streamInfo, setstreamInfo] = useState([]);

  const [moreItems, setmoreItems] = useState(false);
  const [streamIndex, setstreamIndex] = useState(0);

  const [isStreamCreator, setisStreamCreator] = useState([false]);

  const [streamIsPublic, setstreamIsPublic] = useState([false]);

  const { guid } = useParams();

  const urlParams = new URLSearchParams(useLocation().search);
  const selectedItem = urlParams.get('item');

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip">
      {props}
    </Tooltip>
  );

  async function joinStreamOnclick(event) {
    if (guid) {
      if (streamIsPublic && props.loggedInEmail) {
        let result = await joinStream(guid, props.loggedInEmail);
        if (result) {
          set_joined_stream(true);
        } else {
          console.log("error: failed to join")
        }
      }
    }
  }

  async function load_next_items() {
    const next = await get_stream_next(guid, streamIndex + 5);

    for (let i in next.next_items) {
      let query = await get_item_query_from_id(next.next_items[i].item);
      next.next_items[i].query = query;
    } 
    setmoreItems(next.has_more);
    setstreamIndex(next.current_index);
    setstreamInfo(streamInfo.concat(next.next_items));
  }

  // Load items if we have more screen space
  useEffect(() => {
    if (moreItems) {
      let element = document.getElementById("scrollable-content")
      if (element.scrollTop + element.offsetHeight >= element.scrollHeight) {
        load_next_items()
      }
    }
  }, [streamInfo])


  function updateScreenItems() {
    // Check to see if the counter has been initialized or is out of date
    if (typeof updateScreenItems.count == 'undefined' || streamIndex > updateScreenItems.count) {
      // It has not... perform the initialization
      updateScreenItems.count = streamIndex;
    }

    if (moreItems && updateScreenItems.count == streamIndex) {
      let element = document.getElementById("scrollable-content")
      // This 100 pixel offset seems to help with a chrome bug
      if (element.scrollTop + element.clientHeight >= element.scrollHeight-100) {
        updateScreenItems.doneExecuting = true;
        // Update these state fields
        load_next_items();
      }
    }
  }

  // Scroll to latest comment on modal show, or when new comment is added
  useEffect(() => {
    let scroll_div = document.getElementById("comment-div");
    if (scroll_div) {
      scroll_div.scrollTop = scroll_div.scrollHeight;
    }
  }, [commentList]);

  async function showStream(streaminfo) {
    setisStreamCreator(props.loggedInEmail && streaminfo.by == props.loggedInEmail)

    set_joined_stream(((props.loggedInEmail && (streaminfo.users.includes(props.loggedInEmail)) || streaminfo.by == props.loggedInEmail)))

    // Temp
    const next = await get_stream_next(guid);

    // TODO make this look better
    document.getElementById('title-field').textContent = streaminfo.title;
    setstreamData({ by: streaminfo.by, on: streaminfo.on })

    if (streaminfo.items.length > 0) {
      document.getElementById('no_items').style.display = "none";

      for (let i in next.next_items) {
        let query = await get_item_query_from_id(next.next_items[i].item);
        next.next_items[i].query = query;
      }
      setmoreItems(next.has_more);
      setstreamIndex(next.current_index);
      setstreamInfo(next.next_items);
    } else {
      document.getElementById('no_items').style.display = "inline";
    }
  }

  useEffect(() => {

    const handleDOMContentLoaded = () => {
      updateMetaTags();
    };

    // Execute updateMetaTags after the DOMContentLoaded event
    document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

    // Check if we are already joined
    get_stream(guid).then(streaminfo => {
      if (!streaminfo || (streaminfo.type == "private" && !streaminfo.users.includes(props.loggedInEmail))) {
        alert("Invalid stream id")
        // Redirect back to main
        navigate("/", { replace: true });
      }
      // Might be misnamed - more like "has stream"?
      if (streaminfo.by != "anonymous") {
        setstreamIsPublic(true);
        showStream(streaminfo);
      } else {
        alert("Please join stream to view responses")
      }
    })
  }, []);
  // Handles interactions while viewing stream
  // Comments, upvotes, etc
  // Paired with stream.html

  async function deleteStreamItem(stream_guid, item_guid, updater = "anonymous") {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/item`, {
        method: "DELETE",
        body: JSON.stringify({
          item: item_guid,
          by: updater,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });

      if (response.ok) {
        const responseData = await response.json();
        // Show a dialog box with a success message
        alert("Item Removed");
        return responseData;
      } else {
        console.log("Error getting response");
        return false;
      }
    } catch (error) {
      console.error('Error updating stream:', error);
      return false;
    }
  }

  // User interactions with stream items
  async function commentStreamItem(stream_guid, item_guid, comment_text, updater = "anonymous") {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/comment`, {
        method: "PUT",
        body: JSON.stringify({
          item: item_guid,
          comment: comment_text,
          user: updater,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        console.log("Error getting response");
        return false;
      }
    } catch (error) {
      console.error('Error adding comment:', error);
      return false;
    }
  }

  async function voteStreamItem(stream_guid, item_guid, new_vote, updater = "anonymous") {
    try {
      const response = await fetch(`https://sixhats-backend.onrender.com/stream/${stream_guid}/vote`, {
        method: "PUT",
        body: JSON.stringify({
          item: item_guid,
          vote: new_vote,
          user: updater,
        }),
        headers: {
          "Content-type": "application/json; charset=UTF-8"
        }
      });
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        console.log("Error getting response");
        return false;
      }
    } catch (error) {
      console.error('Error setting vote:', error);
      return false;
    }
  }

  // Create the stream card
  // This is in a JS file due to the amount of complicated event listener and state handling involve
  function formatTime(time) {
    if (!time.includes("now")) {
      return time.split("T")[0] + " " + time.split("T")[1].split(".")[0];
    } else {
      return time;
    }
  }

  async function addComment() {
    let comment_text = document.getElementById("input-comment").value;
    if (comment_text != "") {
      document.getElementById("input-comment").value = "";
      let response = await commentStreamItem(guid, activeStreamItem.item, comment_text, props.loggedInEmail);
      if (response) {
        let new_comment = response.comments[response.comments.length - 1];

        let new_item = activeStreamItem;
        if (!new_item.comments) {
          new_item.comments = [];
        }
        new_item.comments = activeStreamItem.comments.concat(new_comment);
        setactiveStreamItem(new_item);
        setcommentList(activeStreamItem.comments);
      }
    }
  }

  function getVote(item) {
    if (item.votes) {
      let user_vote = item.votes.users.filter(obj => {
        return obj.user === props.loggedInEmail;
      });

      if (user_vote.length != 0) {
        return user_vote[0].vote;
      }
    }
    return 0;
  }

  function applyVote(votes, stream_item) {
    if (votes) {
      let updated_stream_info = streamInfo.slice();
      for (let ind in updated_stream_info) {
        if (updated_stream_info[ind].item == stream_item) {
          updated_stream_info[ind].votes = votes.votes;
        }
      }
      setstreamInfo(updated_stream_info);
    } else {
      alert("vote failed");
    }
  }

  async function webShare() {
    // Test compatibility
    if (navigator.share === undefined) {
      console.log('Unsupported share feature');
      return;
    }

    // Handle file urls
    let streamUrl = "https://www.6hats.ai/#/s/" + guid;
    // Share content
    try {
      // TODO set title, that value is not directly availible here
      await navigator.share({ url: streamUrl });
    } catch (error) {
      console.log(`Error sharing: ${error}`);
    }
  }
  return (
    <div id="scrollable-content" className="content-div" onScroll={() => updateScreenItems()}>
      <div className="stream-view">
        <h3 id="title-field" style={{ marginInline: "50px" }}> </h3>
        {(streamData && streamData.by) ?
          <OverlayTrigger
            placement="right"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip(streamData.by)}
          >
            <p id="time-field" style={{ marginInline: "50px" }}>began: {streamData.on} <t /> by:  {streamData.by ? streamData.by.split("@")[0] : null}</p>
          </OverlayTrigger> : null}
        <hr style={{ height: "4px", width: "100%" }} />
        <div id="table_items" className="stream-table">
          {streamInfo.map((streamItem, i) => {
            return <Card className={((streamItem.item == selectedItem) ? 'highlight-item' : '')} id={streamItem.item}>
              <div className={'stream-table-row ' + (i % 2 != 0 ? 'dark-background' : '')}>
                {/* Left div - delete item if non-stream member */}
                {isStreamCreator ?
                  <div className="stream-table-left" onClick={() => {
                    deleteStreamItem(guid, streamItem.item, props.loggedInEmail).then(deleted => {
                      if (deleted) {
                        let updated_stream_info = streamInfo.filter(s => s.item != streamItem.item);
                        setstreamInfo(updated_stream_info);
                      }
                    })
                  }}>
                    <FontAwesomeIcon icon={faX} ize="lg" />
                  </div> : null}
                {/* Center div - display item information */}
                <div className="stream-table-center" onClick={() => {
                  navigate("/?item=" + streamItem.item + "&stream=" + guid, { replace: true });
                }}>
                  <h6> {streamItem.query} </h6>
                  <div style={{ display: "flex" }}>
                    <p style={{ marginRight: ".25rem" }}>added by: </p>
                    {streamItem.by != "anonymous" ? <OverlayTrigger
                      placement="right"
                      delay={{ show: 250, hide: 400 }}
                      overlay={renderTooltip(streamItem.by)}
                    >
                      <p>{streamItem.by.split("@")[0]}</p>
                    </OverlayTrigger> : <p>{streamItem.by.split("@")[0]}</p>}
                  </div>
                </div>
                {
                  (joined_stream || streamIsPublic) ?
                    <div className="stream-table-right" style={{ display: "block", minWidth: "4rem" }}>
                      <div onClick={() => {
                        if (joined_stream) {
                          if (getVote(streamItem) == 1) {
                            // remove upvote
                            voteStreamItem(guid, streamItem.item, 0, props.loggedInEmail).then(votes => {
                              applyVote(votes, streamItem.item);
                            });
                          } else {
                            // Add upvote
                            voteStreamItem(guid, streamItem.item, 1, props.loggedInEmail).then(votes => {
                              applyVote(votes, streamItem.item);
                            });
                          }
                        }
                      }}>
                        <FontAwesomeIcon icon={faArrowUp} style={{ margin: "5px", verticalAlign: "middle" }} className={(getVote(streamItem) == 1) ? "stream-upvote" : null} />
                        <label style={{ verticalAlign: "middle" }} >{(streamItem.votes && streamItem.votes.upvotes) ? streamItem.votes.upvotes : null}</label>
                      </div>
                      <div onClick={() => {
                        if (joined_stream) {
                          if (getVote(streamItem) == -1) {
                            // remove downvote
                            voteStreamItem(guid, streamItem.item, 0, props.loggedInEmail).then(votes => {
                              applyVote(votes, streamItem.item);
                            });
                          } else {
                            // Add downvote
                            voteStreamItem(guid, streamItem.item, -1, props.loggedInEmail).then(votes => {
                              applyVote(votes, streamItem.item);
                            });
                          }
                        }
                      }
                      }>
                        <FontAwesomeIcon icon={faArrowDown} style={{ margin: "5px", verticalAlign: "middle" }} className={(getVote(streamItem) == -1) ? "stream-downvote" : null} />
                        <label style={{ verticalAlign: "middle" }}>{(streamItem.votes && streamItem.votes.downvotes) ? streamItem.votes.downvotes : null}</label>
                      </div>
                      <div onClick={() => {
                        // show modal
                        setcommentTitle(streamItem.query);
                        setcommentList(streamItem.comments);

                        // Set variables needed by add comment button
                        setactiveStreamItem(streamItem);
                        setshowCommentsModal(true);
                      }}>
                        <FontAwesomeIcon icon={faCommentDots} style={{ margin: "5px", verticalAlign: "middle" }} />
                        <label style={{ verticalAlign: "middle" }}>{streamItem.comments ? streamItem.comments.length : null}</label>
                      </div>
                    </div> : null
                }
              </div>
            </Card>
          })}
          {(moreItems) ? <div style={{ display: "flex" }}><FontAwesomeIcon icon={faArrowDown} className="fa-lg" style={{ margin: "auto" }} /></div> : null}
        </div>
        {
          streamInfo.length == 0 ?
            <p id="no_items"> No items added to stream </p> : null
        }
      </div >

      {!joined_stream && props.loggedInEmail ?
        <button className="fixed-button upper-button" onClick={e => joinStreamOnclick(e)}>
          {streamData.by == "Automatic" ? <FontAwesomeIcon icon={faBookmark} /> :
            <FontAwesomeIcon icon={faUserPlus} />
          }
        </button> : null
      }

      < button className="fixed-button upper-left-button" onClick={() => webShare()}>
        <FontAwesomeIcon icon={faArrowUpFromBracket} />
      </button >

      <Modal show={showCommentsModal} onHide={() => setshowCommentsModal(false)}>
        <Modal.Header closeButton>
          <h4 id="query-display">{commentTitle}</h4>
        </Modal.Header>
        <Modal.Body>
          <div id="comment-div" className="modal-body scrollable">
            {commentList ? commentList.map((comment) => {
              return <div className="comment-table-row">
                <p className="modal-comment-left">{formatTime(comment.timestamp)}</p>
                <p className="modal-comment-center"> {comment.comment} </p>
                <div className="modal-comment-right" style={{ display: "inline-block" }}>
                  <p style={{ marginRight: ".25rem", marginBottom: "0rem" }}>added by: </p>
                  {comment.author != "anonymous" ? <OverlayTrigger
                    placement="left"
                    delay={{ show: 250, hide: 400 }}
                    overlay={renderTooltip(comment.author)}
                  >
                    <p>{comment.author.split("@")[0]}</p>
                  </OverlayTrigger> : <p>anonymous</p>}
                </div>
              </div>
            })
              : null}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {joined_stream ?
            <div style={{ display: "flex", width: "100%" }}>
              <input id="input-comment" className="modal-field" style={{ borderRadius: "5px", color: "black", borderWidth: "1px" }}></input>
              <Button id="btn-comment" onClick={e => addComment(e)}>Comment</Button>
            </div> : null
          }
        </Modal.Footer>
      </Modal>
    </div>
  );
}